var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 55,
    viewBox: "0 0 290 55",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "1.66 41.41 1.66 54.07 4.95 54.07 4.95 49.1 8.56 49.1 8.56 46.31 4.95 46.31 4.95 44.2 8.93 44.2 8.93 41.41 1.66 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.01,38.24c0,.91-.73,1.66-1.64,1.66-.91,0-1.66-.73-1.66-1.64s.73-1.66,1.64-1.66c0,0,.01,0,.02,0,.91,0,1.64.73,1.65,1.63,0,0,0,0,0,.01M15.71,38.24c0,.91-.73,1.66-1.64,1.66-.91,0-1.66-.73-1.66-1.64,0-.91.73-1.66,1.64-1.66,0,0,.01,0,.02,0,.91,0,1.64.73,1.65,1.63,0,0,0,0,0,.01M21.75,41.41v7.12c0,1.63-.07,3.24-1.33,4.47-1.07,1.04-2.72,1.42-4.2,1.42s-3.14-.36-4.2-1.42c-1.26-1.23-1.32-2.84-1.32-4.47v-7.12h3.29v6.67c0,1.64.12,3.44,2.23,3.44s2.23-1.8,2.23-3.44v-6.67h3.29Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11,47.08h.32c1.07,0,2.28-.2,2.28-1.58s-1.21-1.58-2.28-1.58h-.32v3.16ZM34.35,54.07h-4.1l-3.1-4.87h-.04v4.87h-3.28v-12.66h4.91c2.49,0,4.4,1.19,4.4,3.91,0,1.74-.97,3.26-2.77,3.58l3.98,5.18Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41 41.41 41 54.07 48.2 54.07 48.2 51.29 44.29 51.29 44.29 49.1 48 49.1 48 46.31 44.29 46.31 44.29 44.2 48.2 44.2 48.2 41.41 41 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.23,
    y: 41.41,
    width: 3.29,
    height: 12.66,
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.02 41.41 65.02 49.15 64.99 49.15 58.96 41.41 55.67 41.41 55.67 54.07 58.96 54.07 58.96 46.31 58.99 46.31 65.02 54.07 68.31 54.07 68.31 41.41 65.02 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.46 41.41 70.46 54.07 77.66 54.07 77.66 51.29 73.75 51.29 73.75 49.1 77.46 49.1 77.46 46.31 73.75 46.31 73.75 44.2 77.66 44.2 77.66 41.41 70.46 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.74,51.55h.41c.98,0,2.62.05,2.62-1.35,0-1.53-1.63-1.38-2.7-1.38h-.36l.02,2.72ZM88.74,46.38h.36c.87,0,1.78-.15,1.78-1.22,0-1.16-1.02-1.23-1.91-1.23h-.23l.02,2.45ZM85.45,54.07v-12.66h4.7c2.25,0,3.76.87,3.76,3.29,0,1.14-.36,2.06-1.39,2.59v.03c1.81.23,2.58,1.46,2.58,3.22,0,2.65-2.27,3.53-4.58,3.53h-5.07Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.82 41.41 96.82 54.07 104.02 54.07 104.02 51.29 100.11 51.29 100.11 49.1 103.82 49.1 103.82 46.31 100.11 46.31 100.11 44.2 104.02 44.2 104.02 41.41 96.82 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01,44.68c-.61-.53-1.39-.83-2.19-.85-.61,0-1.42.36-1.42,1.07s.89,1.02,1.46,1.21l.84.25c1.78.52,3.12,1.42,3.12,3.46,0,1.26-.3,2.55-1.31,3.41-1.02.81-2.29,1.23-3.59,1.19-1.59-.02-3.13-.53-4.43-1.45l1.42-2.66c.82.71,1.8,1.31,2.92,1.31.77,0,1.6-.38,1.6-1.27s-1.3-1.24-2-1.44c-2.07-.59-3.42-1.12-3.42-3.58s1.83-4.26,4.36-4.26c1.39.02,2.75.38,3.97,1.04l-1.32,2.58Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,44.68c-.61-.52-1.38-.82-2.18-.84-.61,0-1.42.36-1.42,1.07s.89,1.02,1.46,1.21l.84.25c1.78.52,3.12,1.42,3.12,3.46,0,1.26-.3,2.55-1.31,3.41-1.02.81-2.29,1.23-3.59,1.19-1.6-.02-3.15-.52-4.45-1.44l1.42-2.66c.82.71,1.8,1.31,2.92,1.31.77,0,1.6-.38,1.6-1.27s-1.3-1.24-2-1.44c-2.07-.59-3.42-1.12-3.42-3.58s1.83-4.26,4.37-4.26c1.38.02,2.74.38,3.96,1.03l-1.31,2.57Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.74 41.41 126.74 54.07 133.94 54.07 133.94 51.29 130.03 51.29 130.03 49.1 133.74 49.1 133.74 46.31 130.03 46.31 130.03 44.2 133.94 44.2 133.94 41.41 126.74 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.26,47.08h.32c1.07,0,2.28-.2,2.28-1.58s-1.21-1.58-2.28-1.58h-.32v3.16ZM146.5,54.07h-4.09l-3.11-4.87h-.03v4.87h-3.29v-12.66h4.92c2.49,0,4.4,1.19,4.4,3.91,0,1.74-.98,3.26-2.77,3.58l3.97,5.18Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.39 41.41 147.39 54.07 154.59 54.07 154.59 51.29 150.68 51.29 150.68 49.1 154.39 49.1 154.39 46.31 150.68 46.31 150.68 44.2 154.59 44.2 154.59 41.41 147.39 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.01,47c-.03,1.85-.17,3.43-1.29,5.01-1.24,1.73-3.11,2.49-5.22,2.49-3.98,0-6.75-2.71-6.75-6.68s2.79-6.82,6.87-6.82c2.6,0,4.62,1.18,5.71,3.55l-3.12,1.31c-.45-1.21-1.42-2.02-2.74-2.02-2.17,0-3.29,2.06-3.29,4s1.17,3.95,3.33,3.95c1.42,0,2.52-.74,2.65-2.2h-2.68v-2.58h6.53Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.51 41.41 176.51 54.07 183.72 54.07 183.72 51.29 179.81 51.29 179.81 49.1 183.52 49.1 183.52 46.31 179.81 46.31 179.81 44.2 183.72 44.2 183.72 41.41 176.51 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.7,44.68c-.61-.52-1.38-.82-2.18-.84-.61,0-1.42.36-1.42,1.07s.89,1.02,1.46,1.21l.84.25c1.78.52,3.12,1.42,3.12,3.46,0,1.26-.3,2.55-1.31,3.41-1.02.8-2.29,1.21-3.59,1.17-1.6-.01-3.15-.52-4.45-1.44l1.42-2.66c.82.71,1.8,1.31,2.92,1.31.77,0,1.59-.38,1.59-1.27s-1.29-1.24-2-1.44c-2.07-.59-3.43-1.12-3.43-3.58s1.83-4.26,4.37-4.26c1.38.03,2.74.38,3.96,1.04l-1.32,2.58Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.09 41.41 196.09 54.07 203.29 54.07 203.29 51.29 199.38 51.29 199.38 49.1 203.09 49.1 203.09 46.31 199.38 46.31 199.38 44.2 203.29 44.2 203.29 41.41 196.09 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.32 41.41 205.32 54.07 212.56 54.07 212.56 51.29 208.62 51.29 208.62 41.41 205.32 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.64 41.41 213.64 54.07 220.88 54.07 220.88 51.29 216.93 51.29 216.93 41.41 213.64 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.15,44.68c-.61-.52-1.38-.82-2.18-.84-.61,0-1.42.36-1.42,1.07s.89,1.02,1.46,1.21l.84.25c1.78.52,3.12,1.42,3.12,3.46,0,1.26-.3,2.55-1.31,3.41-1.02.81-2.29,1.23-3.59,1.19-1.6-.02-3.15-.52-4.45-1.44l1.42-2.66c.82.71,1.8,1.31,2.92,1.31.77,0,1.6-.38,1.6-1.27s-1.3-1.24-2-1.44c-2.07-.59-3.43-1.12-3.43-3.58s1.83-4.26,4.37-4.26c1.38.02,2.73.38,3.95,1.03l-1.3,2.57Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,45.66c-.69-.9-1.76-1.42-2.89-1.4-2.01,0-3.38,1.54-3.38,3.51s1.38,3.44,3.43,3.44c1.1-.01,2.13-.5,2.84-1.34v3.94c-1.09.34-1.88.59-2.9.59-1.76,0-3.46-.67-4.75-1.86-1.34-1.22-2.09-2.97-2.03-4.79,0-1.72.66-3.38,1.86-4.62,1.27-1.29,3-2.03,4.82-2.05,1.04,0,2.06.23,3.01.64v3.93Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.92 41.41 251.92 46.3 247.17 46.3 247.17 41.41 243.87 41.41 243.87 54.07 247.17 54.07 247.17 48.88 251.92 48.88 251.92 54.07 255.21 54.07 255.21 41.41 251.92 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,45.32h.03l1.35,4.03h-2.74l1.37-4.03ZM261.08,41.42l-4.87,12.66h3.49l.87-2.2h4.53l.82,2.2h3.51l-4.76-12.67h-3.6Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.47 41.41 270.47 54.07 273.76 54.07 273.76 49.1 277.37 49.1 277.37 46.31 273.76 46.31 273.76 44.2 277.74 44.2 277.74 41.41 270.47 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.59 41.41 278.59 44.2 281.31 44.2 281.31 54.07 284.61 54.07 284.61 44.2 287.33 44.2 287.33 41.41 278.59 41.41",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.72,9.23c-1.54-1.31-3.49-2.05-5.52-2.09-1.53,0-3.57.88-3.57,2.63s2.25,2.55,3.7,3.01l2.13.62c4.46,1.3,7.9,3.51,7.9,8.61,0,3.13-.77,6.35-3.31,8.48s-5.86,2.97-9.08,2.97c-4.03-.04-7.95-1.29-11.25-3.59l3.56-6.61c2.08,1.8,4.54,3.26,7.39,3.26,1.95,0,4.03-.96,4.03-3.2s-3.27-3.09-5.05-3.6c-5.22-1.44-8.66-2.78-8.66-8.89S7.59.29,14.02.29c3.5.06,6.93.95,10.02,2.6l-3.31,6.35Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.93,16.34c0,5.43,4.07,9.4,9.04,9.4s9.04-3.97,9.04-9.4c0-4.35-4.08-8.32-9.04-8.32s-9.04,3.97-9.04,8.32M62.67,16.3c0,10.2-7.43,17.4-17.7,17.4s-17.7-7.19-17.7-17.4C27.26,6.77,35.75.08,44.97.08s17.7,6.69,17.7,16.22",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,11.7c-1.76-2.24-4.46-3.52-7.3-3.47-5.09,0-8.52,3.85-8.52,8.74s3.48,8.57,8.66,8.57c2.76-.03,5.38-1.25,7.18-3.34v9.82c-2.76.84-4.76,1.47-7.35,1.47-4.44-.01-8.72-1.66-12.02-4.64-3.54-3.13-5.15-7.23-5.15-11.91-.01-4.31,1.68-8.46,4.7-11.53,3.24-3.22,7.62-5.05,12.19-5.08,2.61.02,5.2.56,7.6,1.59v9.81Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 1.12,
    width: 8.32,
    height: 31.52,
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.01,10.86h-.09l-3.44,10.03h6.92l-3.4-10.03ZM115.2,27.16l-2.21,5.48h-8.83L116.49,1.12h9.08l12.07,31.52h-8.88l-2.08-5.48h-11.5Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.53 25.7 158.51 25.7 158.51 32.64 140.21 32.64 140.21 1.12 148.53 1.12 148.53 25.7",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.74 20.27 178.51 1.12 187.55 1.12 173.88 32.64 167.43 32.64 153.97 1.12 163.01 1.12 170.74 20.27",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,10.86h-.09l-3.44,10.03h6.92l-3.4-10.03ZM191.84,27.16l-2.22,5.48h-8.82l12.31-31.52h9.08l12.07,31.52h-8.88l-2.08-5.48h-11.47Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.17 25.7 235.15 25.7 235.15 32.64 216.85 32.64 216.85 1.12 225.17 1.12 225.17 25.7",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,1.12v17.73c0,4.05-.17,8.07-3.35,11.12-2.67,2.59-6.88,3.51-10.61,3.51s-7.94-.92-10.61-3.51c-3.2-3.05-3.35-7.06-3.35-11.12V1.12h8.32v16.6c0,4.09.29,8.57,5.64,8.57s5.65-4.48,5.65-8.57V1.12h8.32Z",
    style: {
      fill: "#029ed4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.21 1.12 269.21 32.64 287.42 32.64 287.42 25.71 277.53 25.71 277.53 20.27 286.91 20.27 286.91 13.33 277.53 13.33 277.53 8.06 287.42 8.06 287.42 1.12 269.21 1.12",
    style: {
      fill: "#029ed4"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.5072d8b9d157fd9bd2980ea4946af942.svg";